import React from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';

interface CallAnsweredCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const CallAnsweredCheckbox: React.FC<CallAnsweredCheckboxProps> = ({
  checked,
  onChange
}) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          sx={{
            color: '#3b82f6',
            '&.Mui-checked': { color: '#3b82f6' }
          }}
        />
      }
      label="Call was answered"
      sx={{
        '& .MuiFormControlLabel-label': {
          fontSize: '0.875rem',
          fontWeight: 500
        }
      }}
    />
  );
};
